<div class="preloader" *ngIf="isSpinnerVisible">
    <div class="spinner">
        <img src="{{imageSrc}}" style="opacity: 1; width: 100px;">
    </div>
</div>